export enum EBillingInvoiceStatus {
  Draft = "draft",
  Open = "open",
  Paid = "paid",
  Cancelled = "cancelled",
  Uncollectable = "uncollectable",
}
